import { convertCentsToDollars, Input, USFormatePriceWithDecimal, USFormatePriceWithoutDecimal, getServiceTotal} from "@thdinc/hpf-shared";
import { PieChart } from "@/components/pieChart/Piechart";
import { useAppSelector } from "@/hooks/hook";
import { Package } from "@/interfaces/Package";
import { GET } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import React, { useEffect, useState } from "react";
import { FaCircle } from "react-icons/fa";
import { AddOnsCalInterface } from "../company/interface";
import ToggleInput from "@/components/toggle/Toggle";
import { iceCubes, portableBar } from "@/constants/Common";

function getAddonPrice(
  addon: AddOnsCalInterface,
  guests: number,
  bartenders: number,
  numberOfHours: number,
  bartenderPrepTime: number
): number {
  console.log('bartenderPrepTime-----:',bartenderPrepTime,'addon------:',addon)
  switch (addon.type) {
    case "bartender":
      return Math.max(addon.price * bartenders, addon.min_price ?? 0);
    // return addon.price * bartenders;
    case "guests":
      return Math.max(addon.price * guests, addon.min_price ?? 0);
    // return addon.price * guests;
    case "hourly":
      if (addon.include_prep_time) {
        return Math.max(addon.price * (numberOfHours + bartenderPrepTime / 60), addon.min_price ?? 0);
      } else {
        return Math.max(addon.price * numberOfHours, addon.min_price ?? 0);
      }
    // return addon.price * numberOfHours;
    case "NumOfCocktails":
      return Math.max(addon.price * getNumberOfCocktails(guests, numberOfHours), addon.min_price ?? 0);
    // return addon.price * getNumberOfCocktails(guests, numberOfHours);
    case "fixed":
    default:
      return Math.max(addon.price, addon.min_price ?? 0);
    // return addon.price;
  }
  // switch (addon.type) {
  //   case "bartender":
  //     return addon.price * bartenders;
  //   case "guests":
  //     return addon.price * guests;
  //   case "hourly":
  //     return addon.price * numberOfHours;
  //   case "NumOfCocktails":
  //     return addon.price * getNumberOfCocktails(guests, numberOfHours);
  //   case "fixed":
  //   default:
  //     return addon.price;
  // }
}
function getNumberOfCocktails(guests: number, numberOfHours: number) {
  const Intguests = Math.ceil(guests);
  const IntHours = Math.ceil(numberOfHours);
  return Intguests * (IntHours + 1);
}
function getNumberOfBartenders(guests: number, guestsPerBartender: number) {
  return Math.ceil(guests / guestsPerBartender);
}

const PackagePriceCalculator = () => {
  const { getRevnuePackage } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const { currentBusiness } = useAppSelector((store) => store.business);
  const [numberOfGuests, setNumberOfGuests] = useState<number>(75);
  const [numberOfHrs, setNumberOfHrs] = useState<number>(0);
  // const [tips, setTips] = useState<boolean>(true);
  const [packageList, setPackageList] = useState<Package[]>([]);
  const [curPackage, setCurPackage] = useState<Package | null>();
  const [revenue, setRevenue] = useState<number>(500);
  const [cost, setCost] = useState<number>(300);
  const [profit, setProfit] = useState<number>(200);
  const [tips, setTips] = useState<boolean>(true);
  const [numberOfBartenders, setNumberOfBartenders] = useState<number>(0);
  useEffect(() => {
    (async () => {
      try {
        const res = await GET(
          `${getRevnuePackage}/?business_id=${currentBusiness}`,
          refreshToken
        );
        if (res.data) {
          setPackageList(res.data);
          setCurPackage(res.data[0]);
          setNumberOfHrs(res.data[0].minHours);
          setTips(res.data[0].tipsOptional);
          const { serviceTotalCost: cst, serviceTotal: rvne } = getServiceTotal(
            res.data[0],
            res.data[0].addons,
            numberOfGuests,
            res.data[0].minHours,
            30,
            tips,
          );
          setCost(cst);
          setRevenue(rvne);
          setProfit(rvne - cst);
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [currentBusiness]);
  useEffect(() => {
    if (curPackage) {
      const { serviceTotalCost: cst, serviceTotal: rvne } = getServiceTotal(
        { ...curPackage, withPrep: curPackage?.withPrep ?? false },
        curPackage.addons || [],
        numberOfGuests,
        numberOfHrs,
        30,
        tips,
        curPackage?.customSupply || [] as any,
        true,
        true,
        true,
      );
      setNumberOfBartenders(
        getNumberOfBartenders(numberOfGuests, curPackage.guestsPerBartender)
      );
      setCost(cst);
      setRevenue(rvne);
      setProfit(rvne - cst);
    }
  }, [numberOfGuests, numberOfHrs, curPackage, tips]);
  return (
    <div className="flex gap-4 bg-white  p-4 rounded-2xl items-start flex-wrap md:flex-nowrap ">
      <div className=" md:w-8/12 w-full ">
        <div className="flex items-center justify-between flex-wrap">
          <div className="flex gap-4 flex-wrap">
            <h3 className="text-xl font-semibold">Price Calculator</h3>
            <div className="flex justify-start gap-1 text-xs">
              <div
                className={`flex items-center gap-2 px-3 py-2 rounded-full `}
              >
                <Input
                  onChange={(e) => setTips(e.target.checked)}
                  // className="w-4 h-4 cursor-pointer accent-primary-red"
                  className="cursor-pointer appearance-none h-3 w-3 border border-gray-300 rounded-full checked:bg-primary-red checked:border-transparent focus:outline-none"
                  type="checkbox"
                  checked={tips}
                  disabled={!curPackage?.tipsOptional}
                  //   checked={selectLang.includes("en")}
                />
                <p>Tip Jar</p>
              </div>
              {/* <div className={`flex items-center gap-2 px-3 py-2 rounded-full`}>
                <Input
                  className="cursor-pointer appearance-none h-3 w-3 border border-gray-300 rounded-full checked:bg-primary-red checked:border-transparent focus:outline-none"
                  type="checkbox"
                  checked={
                    curPackage?.addons ? curPackage?.addons?.length > 0 : false
                  }
                  disabled
                />
                <p>Custom Menu</p>
              </div> */}
              {curPackage?.minPrice ? (
                <div
                  className={`flex items-center gap-2 px-3 py-2 rounded-full`}
                >
                  <p>Minimum Price: ${curPackage?.minPrice / 100}</p>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <select
            className="select-wrapper text-sm   rounded-full cursor-pointer  focus:outline-none  focus:ring-1 focus:ring-primary-red "
            onChange={(e) => {
              const cur = packageList.find(
                (p: Package) => p.id === e.target.value
              );
              setCurPackage(cur);
              cur && setNumberOfHrs(cur?.minHours);
              cur && setTips(cur?.tipsOptional);
            }}
            value={curPackage?.id}
          >
            {packageList?.length > 0 &&
              packageList.map((r: Package) => {
                return (
                  <option key={r.id} value={r.id}>
                    {r.name}
                  </option>
                );
              })}
          </select>
        </div>
        <div className="bg-p-gray p-6 rounded-xl mt-7">
          {/* number of Guests */}
          <div className="w-full  ">
            <div className=" font-semibold text-sm my-2 flex justify-between ">
              <p>Number of Guests</p>
              <div className="flex items-center gap-2">
                <div className=" text-xs  focus:outline-none  focus:ring-1 focus:ring-primary-red  font-semibold">
                  Guests
                </div>
                <input
                  min="30"
                  max="500"
                  className="border w-20 px-3 py-1  rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                  type="number"
                  value={numberOfGuests}
                  onChange={(e: any) => {
                    const val = e.target.value;
                    if (parseInt(val) >= 500) {
                      setNumberOfGuests(500);
                    } else {
                      if (
                        val.indexOf(".") !== -1 &&
                        val.split(".")[1].length > 2
                      ) {
                        const valFloat = Number(
                          parseFloat(e.target.value).toFixed(2)
                        );
                        setNumberOfGuests(valFloat);
                      } else {
                        setNumberOfGuests(e.target.value);
                      }
                    }
                  }}
                />
              </div>
            </div>
            <div className="relative">
              <div className="flex gap-4 items-center">
                <input
                  id="labels-range-input"
                  type="range"
                  value={numberOfGuests}
                  onChange={(e: any) => setNumberOfGuests(e.target.value)}
                  min={25}
                  step={25}
                  max={500}
                  className="w-full h-1 rounded-lg appearance-none cursor-pointer bg-primary-red"
                />
              </div>
            </div>
          </div>
          {/* Number of hrs */}
          <div className="w-full mt-5">
            <div className=" font-semibold text-sm my-2 flex justify-between ">
              <p>Number of Hours</p>
              <div className="flex items-center gap-2">
                <div className=" text-xs  focus:outline-none  focus:ring-1 focus:ring-primary-red  font-semibold">
                  Hr
                </div>
                <input
                  min={1}
                  max="12"
                  className="border w-20 px-3 py-1  rounded-full focus:outline-none  focus:ring-1 focus:ring-primary-red"
                  type="number"
                  value={numberOfHrs}
                  onChange={(e: any) => {
                    const val = e.target.value;
                    if (parseInt(val) >= 200) {
                      setNumberOfHrs(200);
                    } else {
                      if (
                        val.indexOf(".") !== -1 &&
                        val.split(".")[1].length > 2
                      ) {
                        const valFloat = Number(
                          parseFloat(e.target.value).toFixed(2)
                        );
                        setNumberOfHrs(valFloat);
                      } else {
                        setNumberOfHrs(e.target.value);
                      }
                    }
                  }}
                />
              </div>
            </div>
            <div className="relative">
              <div className="flex gap-4 items-center">
                <input
                  id="labels-range-input"
                  type="range"
                  // value={numberOfHrs}
                  value={numberOfHrs}
                  onChange={(e: any) => setNumberOfHrs(e.target.value)}
                  min={1}
                  step={1}
                  max={12}
                  className="w-full h-1 rounded-lg appearance-none cursor-pointer bg-primary-red"
                />
              </div>
            </div>
          </div>
        </div>
        {curPackage && curPackage?.addons && curPackage?.addons?.length > 0 && (
          <div className="w-full bg-white rounded-2xl py-3">
            <p className="md:text-xl text-xl font-semibold">Add-ons</p>
            <div className="flex flex-col gap-4 bg-p-gray p-3 rounded-2xl">
              <div className="flex gap-4 ">
                <div className="flex flex-wrap gap-2 ">
                  {curPackage?.addons?.map((addon) => {
                    return (
                      <div key={addon.id} className="flex items-center gap-2 ">
                        <h1
                          key={addon.id}
                          className="flex items-center gap-2  font-semibold text-gray-500"
                        >
                          <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                          {addon.name} $
                          {USFormatePriceWithoutDecimal(
                            getAddonPrice(
                              addon,
                              numberOfGuests,
                              numberOfBartenders,
                              numberOfHrs,
                              curPackage.prepMins
                            ) / 100
                          )}
                        </h1>
                        <ToggleInput
                        disabled={portableBar === addon.name || addon.name === iceCubes}
                          onChange={() => {
                            setCurPackage((prev) => {
                              if (!prev || !prev.addons) return prev;
                              return {
                                ...prev,
                                addons: prev.addons.map((item) => {
                                  if (item.id === addon.id) {
                                    return {
                                      ...item,
                                      auto_include: !item.auto_include,
                                    };
                                  }
                                  return item;
                                }),
                              };
                            });
                          }}
                          checked={addon.auto_include}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="w-full md:w-4/12 flex justify-center items-center gap-4 flex-col ">
        <div className="flex flex-row gap-6 text-sm">
          <div className="flex flex-col items-center">
            <div className="flex gap-2 items-center ">
              <FaCircle className={`text-[#FFA41D]`} size={10} />
              <p>Revenue</p>
            </div>
            <p className="text-sm">
              ${" "}
              {USFormatePriceWithDecimal(
                convertCentsToDollars(revenue.toString())
              )}
            </p>
          </div>
          <div className="flex flex-col items-center ">
            <div className="flex gap-2 items-center">
              <FaCircle className={`text-[#72C1E2] `} size={10} />
              <p>Cost</p>
            </div>
            <p className="text-sm">
              ${" "}
              {USFormatePriceWithDecimal(
                convertCentsToDollars(cost.toString())
              )}
            </p>
          </div>
          <div className="flex flex-col items-center ">
            <div className="flex gap-2 items-center">
              <FaCircle className={`text-[#67BD8C] `} size={10} />
              <p>Profit</p>
            </div>
            <p className="text-sm">
              ${" "}
              {USFormatePriceWithDecimal(
                convertCentsToDollars(profit.toString())
              )}
            </p>
          </div>
        </div>
        <div className="w-full md:h-52 h-40    flex justify-center">
          <PieChart
            legends={false}
            Profit={profit / 100 as number}
            Revenue={revenue / 100 as number}
            Cost={cost / 100 as number}
            label='$'
          />
        </div>
      </div>
    </div>
  );
};

export default PackagePriceCalculator;
